export class ListItem {
    displayName: string;
    value: string;
    constructor(value: string, displayName: string) {
        this.value = value;
        this.displayName = displayName;
    }
}
